import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/Add';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import HomeIcon from '@mui/icons-material/Home';
import { Container, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
  BreadcrumbsComponent,
  LinkItem,
} from '../../components/Breadcrumbs/Breadcrumbs';
import { Spinner } from '../../components/Spinner/Spinner';
import { GadgetDto } from '../../types/gadgets.types';
import { ChooseModal, MODALS } from './chooseModal';
import { Row } from './components/Row';
import styles from './styles.module.css';
import { useGadgetsPage } from './useGadgetsPage';
import { API } from '../../api/api';
import { URLS } from '../../api/urls';
import { useState } from 'react';
import { GadgetSeoEdit } from './GadgetsPage.type';
import { useAlert } from '../../context/Alert.context';

const linkList: LinkItem[] = [
  {
    name: 'Projects',
    to: '/',
    icon: <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
  },
  {
    name: 'Choice',
    to: '/choice',
    icon: <AccountTreeIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
  },
  {
    name: 'Gadgets',
    to: '',
    icon: <DevicesOtherIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
  },
];

export const GadgetsPage = () => {
  const {
    gadgets,
    loading,
    selectedGadget,
    selectedModel,
    choosenModal,
    closeModal,
    setModal,
    setSelectedGadget,
    setSelectedModel,
    updateGadgetAfterDelete,
    updateGadgetAfterCreate,
    updateGadgetAfterEdit,
    updateGadgetAfterModelDelete,
    updateGadgetAfterCreateModel,
    updateGadgetAfterEditModel,
  } = useGadgetsPage();
  const [seoDefaultValue, setSeoDefaultValue] = useState<undefined | GadgetSeoEdit>(undefined);
  const [isSeoLoading, setIsSeoLoading] = useState(false);
  const { showAlert } = useAlert();

  if (loading)
    return (
      <div className={styles.loader}>
        <Spinner />
      </div>
    );

  const onGadgetEdit = (row: GadgetDto) => {
    setIsSeoLoading(true);
    setSelectedGadget(row);
    setModal(MODALS.EDIT_GADGET);
    API.get(`${URLS.GADGET_SEO}/${row.id}`).then(({data}) => {
      setSeoDefaultValue(data)
    })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() => setIsSeoLoading(false))
  }
  return (
    <Container maxWidth="xl">
      <div className={styles.container}>
        <div className={styles.header}>
          <Typography variant="h2">Gadgets</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              setModal(MODALS.CREATE_GADGET);
            }}
          >
            ADD
          </Button>
        </div>
        <BreadcrumbsComponent linkList={linkList} />
        {!gadgets.length && (
          <div className={styles.loader}>
            <Typography variant="h2">Table is empty.</Typography>
          </div>
        )}
        {!!gadgets.length && (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead className={styles.tableHeader}>
                <TableRow>
                  <TableCell />
                  {['Gadget'].map((item) => (
                    <TableCell className={styles.text} key={item}>
                      {item}
                    </TableCell>
                  ))}
                  <TableCell className={styles.text} align="right">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gadgets.map((row: GadgetDto) => (
                  <Row
                    key={row.id}
                    row={row}
                    onGadgetEdit={() => onGadgetEdit(row)}
                    onGadgetDelete={() => {
                      setSelectedGadget(row);
                      setModal(MODALS.DELETE_GADGET);
                    }}
                    onModelDelete={(model) => {
                      setSelectedModel(model);
                      setModal(MODALS.DELETE_MODEL);
                    }}
                    onModelAdd={(gadgetId: string, gadgetSlug: string) => {
                      setSelectedModel({ gadgetSlug, gadgetId });
                      setModal(MODALS.CREATE_MODEL);
                    }}
                    onModelEdit={(model) => {
                      setSelectedModel({
                        ...model,
                        gadgetId: row.id,
                        gadgetSlug: row.slug,
                      });
                      setModal(MODALS.EDIT_MODEL);
                    }}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
      {
        (!isSeoLoading && <ChooseModal
        seoDefaultValue={seoDefaultValue}
      updateGadgetAfterEditModel={updateGadgetAfterEditModel}
      updateGadgetAfterDelete={updateGadgetAfterDelete}
      updateGadgetAfterCreate={updateGadgetAfterCreate}
      updateGadgetAfterEdit={updateGadgetAfterEdit}
      updateGadgetAfterModelDelete={updateGadgetAfterModelDelete}
      updateGadgetAfterCreateModel={updateGadgetAfterCreateModel}
      choosenModal={choosenModal}
      selectedGadget={selectedGadget}
      selectedModel={selectedModel}
      closeModal={closeModal}
    />)
      }

    </Container>
  );
};
